// Modules
import axios from "axios";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
// Types
import { imageWithPostId, IMarketplaceReviewsPost } from "../interfaces";

type TApiDefaults = {
  embedId: string;
  skuId?: string;
  groupId?: string;
  srcDomain: string;
  lastPostId?: number;
};

export type TPostsFilterOptions = {
  page?: number | string;
  orgerBy?: "provider_created_at";
  sort?: "asc" | "desc";
  ratingFilter?: number | string | undefined;
  current_variant?: "true" | "false";
};

export type TCustomersMediaList = {
  imagesWithPostId: Array<imageWithPostId>;
  postList: Array<IMarketplaceReviewsPost>;
};

export async function getCustomersMediaList(
  apiDefautls: TApiDefaults
): Promise<TCustomersMediaList> {
  const { embedId, skuId, groupId, srcDomain, lastPostId } = apiDefautls;

  let url = `${srcDomain}/fb/marketplace-reviews/image-carousel?embed_id=${embedId}&data=1`;

  if (skuId) {
    url = url + `&sku=${skuId}`;
  }

  if (groupId) {
    url = url + `&group=${groupId}`;
  }

  if (lastPostId) {
    url = url + `&last_post_id=${lastPostId}`;
  }

  try {
    const customersMediaList = await axios(DomainSubstitute(url));

    return customersMediaList.data;
  } catch (e) {
    // TODO: add types to Error `e` to use it to message
    throw new Error("Failed to request to 'image-carousel'");
  }
}

export async function getPostsInfo(
  apiDefautls: TApiDefaults,
  filterOptions: TPostsFilterOptions
) {
  const { embedId, skuId, groupId, srcDomain, lastPostId } = apiDefautls;

  let url = `${srcDomain}/fb/marketplace-reviews?embed_id=${embedId}&data=1`;

  if (skuId) {
    url = url + `&sku=${skuId}`;
  }

  if (groupId) {
    url = url + `&group=${groupId}`;
  }

  if (lastPostId) {
    url = url + `&last_post_id=${lastPostId}`;
  }

  const { orgerBy, page, ratingFilter, sort, current_variant } = filterOptions;

  if (orgerBy) {
    url = url + `&order_by=${orgerBy}`;
  }

  if (page) {
    url = url + `&page=${page}`;
  }

  if (ratingFilter) {
    url = url + `&rating_filter=${ratingFilter}`;
  }

  if (sort) {
    url = url + `&sort=${sort}`;
  }

  if (current_variant) {
    url = url + `&current_variant=${current_variant}`;
  }

  try {
    const customersMediaList = await axios(DomainSubstitute(url));

    return customersMediaList.data;
  } catch (e) {
    console.error(e);
  }
}
